import * as Preact from "preact"

const dom = document.getElementById("mount")

import View from "@fae/source/views/Mount.jsx"

let view = undefined

export default function() {
    if(window.environment == "node") return
    view = Preact.render(Preact.h(View), dom, view)
}
